import React, { Fragment, useEffect, useRef, useState } from 'react';
import { MarkerClusterer } from "@react-google-maps/api";

import InfoWrapper from './InfoWrapper';
import MapMarker from "./MapMarker";


const ClusterWrap = ({ boundsTrigger,
                       closeInfoWindow,
                       hoveredPlaceId,
                       isSuccess,
                       markers,
                       markersLoading,
                       setRequestError }) => {

  const [activeCluster, setActiveCluster] = useState(null);
  const [activePlaceId, setActivePlaceId] = useState(null);

  const infoWindow = useRef();
  const clusterWrapper = useRef();


  useEffect(() => {
    if (hoveredPlaceId) {
      highlightCluster();
    } else {
      activeCluster && activeCluster.clusterIcon.div && activeCluster.clusterIcon.div.classList.remove('active')
      setActiveCluster(null);
    }
  }, [hoveredPlaceId]);


  useEffect(() => {
    closeInfoWindow && infoWindow && infoWindow.current.close();
  }, [closeInfoWindow]);


  const highlightCluster = () => {
    const clusters = clusterWrapper && clusterWrapper.current && clusterWrapper.current.state.markerClusterer.getClusters();
    let currentCluster;

    clusters && clusters.length && clusters.map(cluster => {
      const markers = cluster.getMarkers();
      const hoveredMarker = markers.find(marker => marker.metadata.id === hoveredPlaceId);

      if (hoveredMarker) {
        activeCluster && activeCluster.clusterIcon.div && activeCluster.clusterIcon.div.classList.remove('active');
        cluster.clusterIcon.div.classList.add('active');
        currentCluster = cluster;
      }
    });

    !currentCluster && activeCluster && activeCluster.clusterIcon.div && activeCluster.clusterIcon.div.classList.remove('active');
    setActiveCluster(currentCluster || null);
  };

  const markersData = markers || [];


  return (
    <div>
      { isSuccess && !markersLoading && !boundsTrigger && markersData.length &&
        <MarkerClusterer
          averageCenter
          enableRetinaIcons
          maxZoom={15}
          gridSize={60}
          clusterClass='cluster'
          ref={clusterWrapper}
        >
          {(clusterer) =>
            <Fragment>
              { markersData.map((location, index) => {
                if (location.attributes.lat && location.attributes.long) {
                  return (
                    <MapMarker
                      activePlaceId={activePlaceId}
                      clusterer={clusterer}
                      hoveredPlaceId={hoveredPlaceId}
                      infoWindow={infoWindow}
                      place={location.attributes}
                      key={`marker-${location.attributes.id}-${index}`}
                    />
                  );
                }
              })}
            </Fragment>
          }
        </MarkerClusterer>
      }

      <InfoWrapper
        activePlaceId={activePlaceId}
        ref={infoWindow}
        setActivePlaceId={setActivePlaceId}
        setRequestError={setRequestError}
      />
    </div>
  );
}

export default ClusterWrap;
